/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { isEmpty } from '../../utils/lodashExtend';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import { getMemberships, membershipAllDisabled } from '../../apis/membership';
import { getParams } from '../../utils/params';
import Membership from './MemberShip';
import { MEMBERSHIP_TARGET_TYPE } from '../../constants/MEMBERSHIP';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';

const Memberships = (props) => {
  const [fields] = useState([
    {
      title: "등급명",
      key: "label",
    },
    {
      title: "등급",
      key: "level",
    },
    {
      title: "대상",
      key: "targetType",
      onValue: (v) => MEMBERSHIP_TARGET_TYPE.find(f => f.value === v)?.label
    },
    {
      title: "사용여부",
      key: "isEnable",
      onValue: (v) => v ? <span className="color-main-100">사용</span> : <span className="error">중지</span>
    },
    {
      title: "사용중인 회사",
      key: "membershipHistories",
      onValue: (d) => !isEmpty(d) ? `${d[0].company.name}${d.length > 1 ? ` 외 ${d.length - 1}개` : ""}` : "0개"
    },
    {
      title: "등록일",
      key: "createdTime",
      type: "date"
    },
  ]);
  const [filters] = useState([
    {
      title: "등급명 검색",
      type: "input",
      placeholder: "등급명 입력",
      key: "search.level"
    },
    {
      title: "대상",
      type: "select",
      options: {
        list: [{ label: "전체", value: "all" }, ...MEMBERSHIP_TARGET_TYPE]
      },
      key: "search.targetType"
    },
  ]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);


  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    limit: 10,
    offset: 0,
    search: { targetType: "all" }
  });

  const onDisable = () => {
    systemAlert(
      `멤버십 등급 "${selectedList[0].label}" ${selectedList.length > 1 ? `외 ${selectedList.length - 1}개` : ""}를(을) 사용중지 처리하시겠습니까?\n
      적용중인 회사의 멤버십 기능이 사라질 수 있습니다.
      `,
      {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: "사용중지",
            color: "red",
            onClick: () => {
              membershipAllDisabled({ idx: selectedList.map(item => item.idx) })
                .then(() => {
                  toast.success("사용중지 되었습니다.");
                  reSubmit();

                });
            }
          }
        ]
      },
    );
  };

  const submit = (form) => {

    if (form.search?.targetType === "all") delete form.search?.targetType;
    setIsLoading(true);
    getMemberships(getParams(form))
      .then(res => {
        const { rows = [], count = 0 } = res;
        setTotal(count);
        setList(rows);
      }).finally(() => setIsLoading(false));
  };

  const tableButtons = [{
    label: "사용중지처리",
    disabled: isEmpty(selectedList),
    color: 'red',
    action: onDisable
  }, {
    label: "멤버십 등록",
    action: () => setDetailOpen(true)
  }];


  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  const handleOnSelect = (d) => {
    setSelectedItem(d);
    setDetailOpen(true);
  };


  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideAllCheck
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        onSelect={handleOnSelect}
      />

      <Membership
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />

    </>
  );
};

export default Memberships;